enum ButtonAction {
  BACK = "back",
  CANCEL = "cancel",
  CHECKED_YES = "checked",
  CHECKED_NO = "not_checked",
  CREATE = "create",
  DELETE = "delete",
  DOWNLOAD = "download",
  EDIT = "edit",
  EXPLORE = "explore",
  GRID = "grid",
  INFO = "info",
  LIST = "list",
  MAP = "map",
  OTHER = "other",
  SAVE = "save",
  SHARE = "share",
  SEARCH = "search",
  UPDATE = "update",
  USE = "use",
}

export default ButtonAction;
